import { render, staticRenderFns } from "./drugInfo.vue?vue&type=template&id=fe2754dc&scoped=true"
import script from "./drugInfo.vue?vue&type=script&lang=js"
export * from "./drugInfo.vue?vue&type=script&lang=js"
import style0 from "./drugInfo.vue?vue&type=style&index=0&id=fe2754dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2754dc",
  null
  
)

export default component.exports